"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventGuard = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * Creates a type guard for a given {@link IDashboardEvent} subtype.
 *
 * @param type - type discriminator of the given type
 * @typeParam TEvent - type of the event to check
 */
exports.eventGuard = function (type) {
    return function (obj) {
        return !isEmpty_1.default(obj) && obj.type === type;
    };
};
//# sourceMappingURL=util.js.map